import { Injectable } from "@angular/core";
import { Observable, of, Subject, Subscription } from "rxjs";
import { CatalogPaginationRequest } from "../../../shared/models/CatalogPagination/CatalogPaginationRequest";
import { EstatusJSON } from "../../../shared/models/EstatusJSON";
import { FilterRequest } from "../../../shared/models/Filter/FilterRequest";
import { RoleAPIService } from "../../../shared/services/API/RoleAPI.service";

@Injectable({
  providedIn: "root",
})
export class RoleService {
  
  public isLoading$: Subject<boolean> = new Subject<boolean>();
  constructor(private roleService: RoleAPIService) {
  }

  setLoading(resp) {
    this.isLoading$.next(resp);
  }

  getLoading() {
    return this.isLoading$.asObservable();
  }


  getRoles(): any {
    return this.roleService.getRoles();
  }

  delete(RoleId): any{
    return this.roleService.delete(RoleId);
  }

  getUpdateRole(id: string): Observable<EstatusJSON>{
    return this.roleService.getUpdateRole(id);
  }

  postInsertRole(formData: any): Observable<EstatusJSON> {
    return this.roleService.postInsertRole(formData);
  }

  postUpdateRole(formData: any): Observable<EstatusJSON> {
    return this.roleService.postUpdateRole(formData);
  }

  //paginacion
  getFilterValues(request : FilterRequest[]) {
    return this.roleService.getFilterValues(request);
  }

  getPage(pageRequest: CatalogPaginationRequest) {
    return this.roleService.getPage(pageRequest);
  }

  getCount(pageRequest: CatalogPaginationRequest) {
    return this.roleService.getCount(pageRequest);
  }

}
